// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const storeId = "88026380";
// // const accessToken = "secret_tCeDaKfQgTEMUcKzrCpUdXJwU2N5nC8W";
// // const accessToken = "secret_kRcPTGe3QT5ra6F4Jn2mP9xwuGk2ZbCL";
// const accessToken = "secret_Jx3TRcj9PWcuhpjsygNwRfkpyUytxtDg";

// const PaymentPage = () => {
//   const [paymentOptions, setPaymentOptions] = useState([]);
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const [cartItems, setCartItems] = useState([]);
//   const [customerInfo, setCustomerInfo] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     address1: "",
//     city: "",
//     state: "",
//     postalCode: "",
//     country: "",
//     mobile: "",
//   });
//   const formRef = useRef(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Retrieve customer details from localStorage
//         const customerData = localStorage.getItem("customerDetails");
//         if (customerData) {
//           const parsedCustomerData = JSON.parse(customerData);
//           // Parse the name into first and last name
//           const nameParts = parsedCustomerData.name.split(" ");
//           const firstName = nameParts[0] || "";
//           const lastName = nameParts.slice(1).join(" ") || "";

//           setCustomerInfo({
//             firstName: firstName,
//             lastName: lastName,
//             email: parsedCustomerData.email || "",
//             address1: parsedCustomerData.address || "",
//             city: parsedCustomerData.city || "",
//             state: parsedCustomerData.state || "",
//             postalCode: parsedCustomerData.zip || "",
//             country: "", // Default to US, can be made dynamic if needed
//           });
//         }

//         const [paymentRes] = await Promise.all([
//           axios.get(
//             `https://app.ecwid.com/api/v3/${storeId}/profile/paymentOptions`,
//             {
//               headers: {
//                 Authorization: `Bearer ${accessToken}`,
//               },
//             }
//           ),
//         ]);

//         setPaymentOptions(paymentRes.data || []);
//         const cartData = localStorage.getItem("cart");
//         const parsed = cartData ? JSON.parse(cartData) : [];
//         setCartItems(parsed);
//         setLoading(false);
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load payment options.");
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   // Helper function to create a hidden input element.
//   const createHiddenInput = (name, value) => {
//     const input = document.createElement("input");
//     input.type = "hidden";
//     input.name = name;
//     input.value = value;
//     return input;
//   };

//   const handlePlugnPaySubmit = () => {
//     const form = formRef.current;
//     if (!form) return;

//     // Clear any previous hidden inputs
//     form.innerHTML = "";

//     // 1. Add static and customer info fields
//     const pnpCustomerInfo = {
//       pt_gateway_account: "pnpdemo2", // Your Plug'n Pay gateway account
//       pd_display_items: "yes",
//       pt_billing_name: `${customerInfo.firstName} ${customerInfo.lastName}`,
//       pt_billing_first_name: customerInfo.firstName,
//       pt_billing_last_name: customerInfo.lastName,
//       pt_billing_email_address: customerInfo.email,
//       pt_billing_address_1: customerInfo.address1,
//       pt_billing_city: customerInfo.city,
//       pt_billing_state: customerInfo.state,
//       pt_billing_postal_code: customerInfo.postalCode,
//       pt_billing_country: customerInfo.country,
//     };

//     for (const [key, value] of Object.entries(pnpCustomerInfo)) {
//       form.appendChild(createHiddenInput(key, value));
//     }

//     // 2. Add dynamic itemization fields from the cart
//     cartItems.forEach((item, index) => {
//       const itemNumber = index + 1;
//       form.appendChild(
//         createHiddenInput(`pt_item_identifier_${itemNumber}`, item.id)
//       );
//       form.appendChild(
//         createHiddenInput(`pt_item_description_${itemNumber}`, item.name)
//       );
//       form.appendChild(
//         createHiddenInput(`pt_item_cost_${itemNumber}`, item.price.toFixed(2))
//       );
//       form.appendChild(
//         createHiddenInput(`pt_item_quantity_${itemNumber}`, item.quantity)
//       );
//     });

//     // 3. Add final transaction amount
//     const subtotal = cartItems.reduce(
//       (sum, item) => sum + item.price * item.quantity,
//       0
//     );
//     // const shippingCost = cartItems.length > 0 ? 5.00 : 0;
//     const vatRate = 0.05;
//     const vat = subtotal * vatRate;
//     const total = subtotal + vat;
//     form.appendChild(
//       createHiddenInput("pt_transaction_amount", total.toFixed(2))
//     );

//     // 4. Submit the form to redirect to Plug'n Pay in a new tab
//     form.target = "_blank";
//     form.submit();

//     // After submitting, redirect to cart after a delay to simulate completion
//     setTimeout(() => {
//       setSubmitting(false);
//       // Clear the cart and customer details
//       localStorage.removeItem("cart");
//       localStorage.removeItem("customerDetails");
//       // Redirect to cart page
//       navigate("/cart");
//     }, 3000); // Redirect after 3 seconds
//   };

//   // Handler for Fygaro payment submission
//   const handleFygaroSubmit = () => {
//     const FYGARO_BASE_URL =
//       "https://www.fygaro.com/en/pb/effa6e2f-220d-4452-be01-2184e920dfe6";

//     // Calculate cart totals
//     const subtotal = cartItems.reduce(
//       (sum, item) => sum + item.price * item.quantity,
//       0
//     );
//     // const shippingCost = cartItems.length > 0 ? 5.00 : 0;
//     const taxRate = 0.05;
//     const tax = subtotal * taxRate;
//     const totalAmount = subtotal + tax;

//     // Get product details dynamically from cart
//     let productDetails = "";
//     cartItems.forEach((item) => {
//       productDetails += `- ${item.name} (Qty: ${item.quantity}): $${(
//         item.price * item.quantity
//       ).toFixed(2)}\n`;
//     });

//     // Combine all information into a single string for the client_note
//     const clientNote = `
// Customer Details:
// Name: ${customerInfo.firstName} ${customerInfo.lastName}
// Email: ${customerInfo.email}
// Address: ${customerInfo.address1}, ${customerInfo.city}, ${
//       customerInfo.state
//     }, ${customerInfo.postalCode}, ${customerInfo.country}

// --------------------
// Order Details:
// ${productDetails}
// Subtotal: $${subtotal.toFixed(2)}
// Tax: $${tax.toFixed(2)}
// Total: $${totalAmount.toFixed(2)}
// `;

//     // Create the dynamic URL with the amount and the URL-encoded client_note
//     const dynamicURL = `${FYGARO_BASE_URL}?amount=${totalAmount.toFixed(
//       2
//     )}&client_note=${encodeURIComponent(clientNote)}`;

//     // Redirect the user to the Fygaro payment page
//     window.location.href = dynamicURL;
//   };

//   const handleProceed = async () => {
//     if (!selectedOption) return alert("Please select a payment method.");
//     setSubmitting(true);
//     // Check if the selected payment method is PlugnPay or Fygaro
//     if (selectedOption.title === "PlugnPay") {
//       handlePlugnPaySubmit(); // Redirect to PlugnPay gateway
//       setSubmitting(false);
//       return;
//     }

//     if (selectedOption.title === "Fygaro") {
//       handleFygaroSubmit(); // Redirect to Fygaro gateway
//       setSubmitting(false);
//       return;
//     }

//     // if (selectedOption.title === "PlugnPay") {
//     //   setSubmitting(true);

//     //   handlePlugnPaySubmit();
//     //   return;
//     // }

//     // if (selectedOption.title === "Fygaro") {
//     //   setSubmitting(true);

//     //   handleFygaroSubmit();
//     //   return;
//     // }

//     setSubmitting(true);

//     const orderData = {
//       email: customerInfo.email || "testuser@example.com",
//       // paymentMethod: selectedOption.title,
//       // paymentMethodId: selectedOption.id,
//       paymentDetails: {
//         method: selectedOption.title, // Use the correct key for payment method
//       },
//       // Add billingPerson object to match what OrderDetails expects
//       billingPerson: {
//         name: `${customerInfo.firstName} ${customerInfo.lastName}`,
//         firstName: customerInfo.firstName,
//         lastName: customerInfo.lastName,
//         email: customerInfo.email,
//         street: customerInfo.address1,
//         city: customerInfo.city,
//         stateOrProvince: customerInfo.state,
//         postalCode: customerInfo.postalCode,
//         countryName: customerInfo.country,
//         phone: customerInfo.mobile || "",
//       },
//       // Keep the customer object for completeness
//       // customer: {
//       //   firstName: customerInfo.firstName,
//       //   lastName: customerInfo.lastName,
//       //   mobile: customerInfo.mobile, // Include mobile number phone
//       //   email: customerInfo.email,
//       //   address1: customerInfo.address1,
//       //   city: customerInfo.city,
//       //   state: customerInfo.state,
//       //   postalCode: customerInfo.postalCode,
//       //   country: customerInfo.country,
//       // },
//       items: cartItems.map((item) => ({
//         id: item.id,
//         name: item.name,
//         quantity: item.quantity,
//         price: item.price,
//         imageUrl: item.imageUrl || "/assets/No-img.png.png", // Add image URL
//       })),
//       total:
//         cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0) *
//         1.05,
//     };

//     try {
//       console.log("Order created:", orderData);
//       const res = await axios.post(
//         `https://app.ecwid.com/api/v3/${storeId}/orders`,
//         orderData,
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );
//       console.log("Order created:", res.data);
//       // Show a success message or navigate to an order confirmation page
//       alert("Order successfully created!");
//       // navigate("/YourOrders", { state: { order: res.data } });
//       navigate(`/order-details/${orderData.id || "12345"}`, {
//         state: { order: orderData },
//       });

//       // Clear the cart and customer details after successful order
//       localStorage.removeItem("cart");
//       localStorage.removeItem("customerDetails");
//       navigate("/YourOrders");
//     } catch (err) {
//       // console.error("Order error:", err?.response?.data || err.message);
//       console.error("Order error:", err.message);
//       alert("Failed to place order.");
//     } finally {
//       setSubmitting(false);
//     }
//     // console.log("Order created:", res.data);
//   };

//   if (loading)
//     return (
//       <div className="flex justify-center items-center h-80 text-lg text-gray-700">
//         Loading payment options...
//       </div>
//     );
//   if (error)
//     return <div className="text-red-600 text-center mt-10">{error}</div>;

//   return (
//     <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
//       {/* Hidden form for Plug'n Pay */}
//       <form
//         ref={formRef}
//         method="POST"
//         action="https://paywithcardx.com/pay/"
//         style={{ display: "none" }}
//       />

//       <div className="max-w-2xl mx-auto bg-white shadow-md rounded-xl p-8 space-y-8 border border-gray-200">
//         <div className="text-center">
//           <h2 className="text-xl lg:text-3xl font-extrabold text-gray-800">
//             💳 Choose Your Payment Method
//           </h2>
//           <p className="mt-2 text-gray-500">
//             Securely complete your purchase by selecting a payment method
//           </p>
//         </div>

//         <div className="space-y-4">
//           {/* Add PlugnPay as a payment option */}
//           <div
//             onClick={() =>
//               setSelectedOption({ id: "plugnpay", title: "PlugnPay" })
//             }
//             className={`flex items-start gap-4 p-4 border rounded-lg cursor-pointer transition hover:shadow-sm ${
//               selectedOption?.id === "plugnpay"
//                 ? "border-[#82b016] bg-green-50"
//                 : "border-gray-300"
//             }`}
//           >
//             <input
//               type="radio"
//               name="payment"
//               checked={selectedOption?.id === "plugnpay"}
//               onChange={() =>
//                 setSelectedOption({ id: "plugnpay", title: "PlugnPay" })
//               }
//               className="mt-1 h-4 w-4 accent-[#82b016]"
//             />
//             <div>
//               <p className="font-semibold text-gray-800">PlugnPay</p>
//               <p className="text-sm text-gray-500">
//                 Pay securely with PlugnPay gateway
//               </p>
//             </div>
//           </div>

//           {/* Add Fygaro as a payment option */}
//           <div
//             onClick={() => setSelectedOption({ id: "fygaro", title: "Fygaro" })}
//             className={`flex items-start gap-4 p-4 border rounded-lg cursor-pointer transition hover:shadow-sm ${
//               selectedOption?.id === "fygaro"
//                 ? "border-[#82b016] bg-green-50"
//                 : "border-gray-300"
//             }`}
//           >
//             <input
//               type="radio"
//               name="payment"
//               checked={selectedOption?.id === "fygaro"}
//               onChange={() =>
//                 setSelectedOption({ id: "fygaro", title: "Fygaro" })
//               }
//               className="mt-1 h-4 w-4 accent-[#82b016]"
//             />
//             <div>
//               <p className="font-semibold text-gray-800">Fygaro</p>
//               <p className="text-sm text-gray-500">
//                 Pay securely with Fygaro gateway
//               </p>
//             </div>
//           </div>

//           {paymentOptions.map((option) => (
//             <div
//               key={option.id}
//               onClick={() => setSelectedOption(option)}
//               className={`flex items-start gap-4 p-4 border rounded-lg cursor-pointer transition hover:shadow-sm ${
//                 selectedOption?.id === option.id
//                   ? "border-[#82b016] bg-green-50"
//                   : "border-gray-300"
//               }`}
//             >
//               <input
//                 type="radio"
//                 name="payment"
//                 checked={selectedOption?.id === option.id}
//                 onChange={() => setSelectedOption(option)}
//                 className="mt-1 h-4 w-4 accent-[#82b016]"
//               />
//               <div>
//                 <p className="font-semibold text-gray-800">
//                   {option.checkoutTitle}
//                 </p>
//                 <p className="text-sm text-gray-500">
//                   {option.checkoutDescription}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="pt-6">
//           <button
//             type="button"
//             onClick={handleProceed}
//             disabled={submitting}
//             className={`w-full px-6 py-3 text-lg font-semibold rounded-lg shadow-sm transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-xl
//  ${
//    submitting
//      ? "bg-gray-400 cursor-not-allowed"
//      : "bg-gradient-to-r from-[#82b016] to-green-600 hover:from-[#6fa010] hover:to-green-700 text-white font-bold"
//  }`}
//           >
//             {submitting ? "Processing..." : "Proceed to Payment"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentPage;




import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const storeId = localStorage.getItem('storeId') || "88026380";
const accessToken = localStorage.getItem('accessToken') || "secret_Jx3TRcj9PWcuhpjsygNwRfkpyUytxtDg";


const PaymentPage = () => {
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [customerInfo, setCustomerInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address1: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    mobile: "",
  });
  const formRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Retrieve customer details from localStorage
        const customerData = localStorage.getItem("customerDetails");
        if (customerData) {
          const parsedCustomerData = JSON.parse(customerData);
          // Parse the name into first and last name
          const nameParts = parsedCustomerData.name.split(" ");
          const firstName = nameParts[0] || "";
          const lastName = nameParts.slice(1).join(" ") || "";

          setCustomerInfo({
            firstName: firstName,
            lastName: lastName,
            email: parsedCustomerData.email || "",
            address1: parsedCustomerData.address || "",
            city: parsedCustomerData.city || "",
            state: parsedCustomerData.state || "",
            postalCode: parsedCustomerData.zip || "",
            country: "", // Default to US, can be made dynamic if needed
          });
        }

        const [paymentRes] = await Promise.all([
          axios.get(
            `https://app.ecwid.com/api/v3/${storeId}/profile/paymentOptions`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          ),
        ]);

        setPaymentOptions(paymentRes.data || []);
        const cartData = localStorage.getItem("cart");
        const parsed = cartData ? JSON.parse(cartData) : [];
        setCartItems(parsed);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Failed to load payment options.");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const createHiddenInput = (name, value) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  };

  const handlePlugnPaySubmit = () => {
    const form = formRef.current;
    if (!form) return;

    // Clear any previous hidden inputs
    form.innerHTML = "";

    // 1. Add static and customer info fields
    const pnpCustomerInfo = {
      pt_gateway_account: "pnpdemo2", // Your Plug'n Pay gateway account
      pd_display_items: "yes",
      pt_billing_name: `${customerInfo.firstName} ${customerInfo.lastName}`,
      pt_billing_first_name: customerInfo.firstName,
      pt_billing_last_name: customerInfo.lastName,
      pt_billing_email_address: customerInfo.email,
      pt_billing_address_1: customerInfo.address1,
      pt_billing_city: customerInfo.city,
      pt_billing_state: customerInfo.state,
      pt_billing_postal_code: customerInfo.postalCode,
      pt_billing_country: customerInfo.country,
    };

    for (const [key, value] of Object.entries(pnpCustomerInfo)) {
      form.appendChild(createHiddenInput(key, value));
    }

    // 2. Add dynamic itemization fields from the cart
    cartItems.forEach((item, index) => {
      const itemNumber = index + 1;
      form.appendChild(
        createHiddenInput(`pt_item_identifier_${itemNumber}`, item.id)
      );
      form.appendChild(
        createHiddenInput(`pt_item_description_${itemNumber}`, item.name)
      );
      form.appendChild(
        createHiddenInput(`pt_item_cost_${itemNumber}`, item.price.toFixed(2))
      );
      form.appendChild(
        createHiddenInput(`pt_item_quantity_${itemNumber}`, item.quantity)
      );
    });

    // 3. Add final transaction amount
    const subtotal = cartItems.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    // const shippingCost = cartItems.length > 0 ? 5.00 : 0;
    const vatRate = 0.05;
    const vat = subtotal * vatRate;
    const total = subtotal + vat;
    form.appendChild(
      createHiddenInput("pt_transaction_amount", total.toFixed(2))
    );

    // 4. Submit the form to redirect to Plug'n Pay in a new tab
    form.target = "_blank";
    form.submit();

    // After submitting, redirect to cart after a delay to simulate completion
    setTimeout(() => {
      setSubmitting(false);
      // Clear the cart and customer details
      localStorage.removeItem("cart");
      localStorage.removeItem("customerDetails");
      // Redirect to cart page
      navigate("/cart");
    }, 3000); // Redirect after 3 seconds
  };

  // Handler for Fygaro payment submission
  const handleFygaroSubmit = () => {
    const FYGARO_BASE_URL =
      "https://www.fygaro.com/en/pb/effa6e2f-220d-4452-be01-2184e920dfe6";

    // Calculate cart totals
    const subtotal = cartItems.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    // const shippingCost = cartItems.length > 0 ? 5.00 : 0;
    const taxRate = 0.05;
    const tax = subtotal * taxRate;
    const totalAmount = subtotal + tax;

    // Get product details dynamically from cart
    let productDetails = "";
    cartItems.forEach((item) => {
      productDetails += `- ${item.name} (Qty: ${item.quantity}): $${(
        item.price * item.quantity
      ).toFixed(2)}\n`;
    });

    // Combine all information into a single string for the client_note
    const clientNote = `
Customer Details:
Name: ${customerInfo.firstName} ${customerInfo.lastName}
Email: ${customerInfo.email}
Address: ${customerInfo.address1}, ${customerInfo.city}, ${
      customerInfo.state
    }, ${customerInfo.postalCode}, ${customerInfo.country}

--------------------
Order Details:
${productDetails}
Subtotal: $${subtotal.toFixed(2)}
Tax: $${tax.toFixed(2)}
Total: $${totalAmount.toFixed(2)}
`;

    // Create the dynamic URL with the amount and the URL-encoded client_note
    const dynamicURL = `${FYGARO_BASE_URL}?amount=${totalAmount.toFixed(
      2
    )}&client_note=${encodeURIComponent(clientNote)}`;

    // Redirect the user to the Fygaro payment page
    window.location.href = dynamicURL;
  };

  const handleProceed = async () => {
    if (!selectedOption) return alert("Please select a payment method.");
    setSubmitting(true);
    // Check if the selected payment method is PlugnPay or Fygaro
    if (selectedOption.title === "PlugnPay") {
      handlePlugnPaySubmit(); // Redirect to PlugnPay gateway
      setSubmitting(false);
      return;
    }

    if (selectedOption.title === "Fygaro") {
      handleFygaroSubmit(); // Redirect to Fygaro gateway
      setSubmitting(false);
      return;
    }

    // if (selectedOption.title === "PlugnPay") {
    //   setSubmitting(true);

    //   handlePlugnPaySubmit();
    //   return;
    // }

    // if (selectedOption.title === "Fygaro") {
    //   setSubmitting(true);

    //   handleFygaroSubmit();
    //   return;
    // }

    setSubmitting(true);

    const orderData = {
      email: customerInfo.email || "testuser@example.com",
      // paymentMethod: selectedOption.title,
      // paymentMethodId: selectedOption.id,
      paymentDetails: {
        method: selectedOption.title, // Use the correct key for payment method
      },
      // Add billingPerson object to match what OrderDetails expects
      billingPerson: {
        name: `${customerInfo.firstName} ${customerInfo.lastName}`,
        firstName: customerInfo.firstName,
        lastName: customerInfo.lastName,
        email: customerInfo.email,
        street: customerInfo.address1,
        city: customerInfo.city,
        stateOrProvince: customerInfo.state,
        postalCode: customerInfo.postalCode,
        countryName: customerInfo.country,
        phone: customerInfo.mobile || "",
      },
      items: cartItems.map((item) => ({
        id: item.id,
        name: item.name,
        quantity: item.quantity,
        price: item.price,
        imageUrl: item.imageUrl || "/assets/No-img.png.png", // Add image URL
      })),
      total:
        cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0) *
        1.05,
    };

    try {
      console.log("Order created:", orderData);
      const res = await axios.post(
        `https://app.ecwid.com/api/v3/${storeId}/orders`,
        orderData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      console.log("Order created:", res.data);
      // Show a success message or navigate to an order confirmation page
      alert("Order successfully created!");
      // navigate("/YourOrders", { state: { order: res.data } });
      navigate(`/order-details/${orderData.id || "12345"}`, {
        state: { order: orderData },
      });

      localStorage.removeItem("cart");
      localStorage.removeItem("customerDetails");
      navigate("/YourOrders");
    } catch (err) {
      console.error("Order error:", err.message);
      alert("Failed to place order.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-80 text-lg text-gray-700">
        Loading payment options...
      </div>
    );
  if (error)
    return <div className="text-red-600 text-center mt-10">{error}</div>;

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      {/* Hidden form for Plug'n Pay */}
      <form
        ref={formRef}
        method="POST"
        action="https://paywithcardx.com/pay/"
        style={{ display: "none" }}
      />

      <div className="max-w-2xl mx-auto bg-white shadow-md rounded-xl p-8 space-y-8 border border-gray-200">
        <div className="text-center">
          <h2 className="text-xl lg:text-3xl font-extrabold text-gray-800">
            💳 Choose Your Payment Method
          </h2>
          <p className="mt-2 text-gray-500">
            Securely complete your purchase by selecting a payment method
          </p>
        </div>

        <div className="space-y-4">
          {/* Add PlugnPay as a payment option */}
          <div
            onClick={() =>
              setSelectedOption({ id: "plugnpay", title: "PlugnPay" })
            }
            className={`flex items-start gap-4 p-4 border rounded-lg cursor-pointer transition hover:shadow-sm ${
              selectedOption?.id === "plugnpay"
                ? "border-[#82b016] bg-green-50"
                : "border-gray-300"
            }`}
          >
            <input
              type="radio"
              name="payment"
              checked={selectedOption?.id === "plugnpay"}
              onChange={() =>
                setSelectedOption({ id: "plugnpay", title: "PlugnPay" })
              }
              className="mt-1 h-4 w-4 accent-[#82b016]"
            />
            <div>
              <p className="font-semibold text-gray-800">PlugnPay</p>
              <p className="text-sm text-gray-500">
                Pay securely with PlugnPay gateway
              </p>
            </div>
          </div>

          {/* Add Fygaro as a payment option */}
          <div
            onClick={() => setSelectedOption({ id: "fygaro", title: "Fygaro" })}
            className={`flex items-start gap-4 p-4 border rounded-lg cursor-pointer transition hover:shadow-sm ${
              selectedOption?.id === "fygaro"
                ? "border-[#82b016] bg-green-50"
                : "border-gray-300"
            }`}
          >
            <input
              type="radio"
              name="payment"
              checked={selectedOption?.id === "fygaro"}
              onChange={() =>
                setSelectedOption({ id: "fygaro", title: "Fygaro" })
              }
              className="mt-1 h-4 w-4 accent-[#82b016]"
            />
            <div>
              <p className="font-semibold text-gray-800">Fygaro</p>
              <p className="text-sm text-gray-500">
                Pay securely with Fygaro gateway
              </p>
            </div>
          </div>

          {paymentOptions.map((option) => (
            <div
              key={option.id}
              onClick={() => setSelectedOption(option)}
              className={`flex items-start gap-4 p-4 border rounded-lg cursor-pointer transition hover:shadow-sm ${
                selectedOption?.id === option.id
                  ? "border-[#82b016] bg-green-50"
                  : "border-gray-300"
              }`}
            >
              <input
                type="radio"
                name="payment"
                checked={selectedOption?.id === option.id}
                onChange={() => setSelectedOption(option)}
                className="mt-1 h-4 w-4 accent-[#82b016]"
              />
              <div>
                <p className="font-semibold text-gray-800">
                  {option.checkoutTitle}
                </p>
                <p className="text-sm text-gray-500">
                  {option.checkoutDescription}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="pt-6">
          <button
            type="button"
            onClick={handleProceed}
            disabled={submitting}
            className={`w-full px-6 py-3 text-lg font-semibold rounded-lg shadow-sm transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-xl
 ${
   submitting
     ? "bg-gray-400 cursor-not-allowed"
     : "bg-gradient-to-r from-[#82b016] to-green-600 hover:from-[#6fa010] hover:to-green-700 text-white font-bold"
 }`}
          >
            {submitting ? "Processing..." : "Proceed to Payment"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
